import {Partner} from "../../entities/Partner.ts";
import {PartnerRepository} from "../../../repositories/PartnerRepository.ts";

export class WhoAmIUseCase {
  constructor(private readonly partnerRepository: PartnerRepository) {}

  async whoAmI(role: string, partnerId: string): Promise<Partner | null> {
    return this.partnerRepository.whoAmI(role, partnerId);
  }
}
